<template>
  <div class="cart__head-overlay">
      <div class="cart__close-icon" @click="emit('toggle-cart',false)" >
        <svg class="icon icon--xl">
          <use href="#x"></use>
        </svg>
      </div>
  </div>
  <div class="cart__head">
    <div class="cart__head-text">
      <div class="text-xl text-medium text-medium-blue">Cart</div>
      <span class="total-cart-items hide">{{ totalCartItems }}</span>
    </div>
  </div>

  <div v-if="!isEmpty" class="cart__message">
    <div class="cart__message-text text-center">
      <span v-if="!hasFreeShipping" v-html="unlockShippingText"></span>
      <div v-if="cartData.enableGiftWithPurchase" class="cart__free-gift">
        <span v-if="hasFreeShipping && !hasFreeGift" v-html="unlockFreeGiftText"></span>
        <span v-if="hasFreeGift" v-html="cartData.gift_text_html"></span>
      </div>
      <span v-else-if="hasFreeShipping">
        <svg class="icon icon--sm"><use href="#truck"></use></svg>
        You’ve unlocked free shipping!
      </span>
    </div>
    <div class="cart__shipping-bar" v-if="!hasFreeShipping">
      <div class="cart__shipping-progess-wrapper">
        <progress max="100" :value="freeShippingPercentComplete" class="cart__shipping-progess"></progress>
      </div>
      <div v-if="cartData.enableGiftWithPurchase" class="cart__shipping-progess-point --gift" :class="{'--active': hasFreeGift}">
        <svg><use href="#giveaway"></use></svg>
      </div>
    </div>
  </div>

  <div v-else class="cart__message cart__message--empty">
    <div class="cart__message-text text-center">
      <span>{{ unlockShippingText }} <a href="/collections/shop">Shop Now</a></span>
    </div>
  </div>

  <ul class="cart__footer-icons">
    <li class="cart__footer-icon">
      <svg class="icon">
        <use href="#smiley"></use>
      </svg>
      <span v-html="cartData.happiness_guarantee"></span>
    </li>
    <li class="cart__footer-icon">
      <svg class="icon">
        <use href="#truck"></use>
      </svg>
      <span v-html="cartData.shipping_time"></span>
    </li>
  </ul>

</template>

<script setup>
  import { ref, computed, toRefs } from 'vue';

  const props = defineProps({
    isEmpty: {
      type: Boolean,
      default: false
    },

    cartData: {
      type: Object,
      default: ({})
    },

    cartTotal: {
      type: Number,
      default: 0
    },

    totalCartItems: {
      type: Number,
      default: 0
    },

    hasFreeShipping: {
      type: Boolean,
      default: false
    },

    hasFreeGift: {
      type: Boolean,
      default: false
    },

    freeShippingMin: {
      type: Number,
      default: 0
    },

    freeGiftMin: {
      type: Number,
      default: 0
    }
  })

  const { cartData, cartTotal, totalCartItems, freeShippingMin, freeGiftMin } = toRefs(props)
  const emit = defineEmits(['toggle-cart'])

  const unlockShippingText = computed(() => {
    const freeShippingRemaining = freeShippingMin.value - cartTotal.value;
    const inputString = /\[\{\{\{ remaining \}\}\}\]/g;

    return cartData.value.to_unlock_shipping.replace(inputString, formatPrice(freeShippingRemaining));
  })

  const unlockFreeGiftText = computed(() => {
    const freeGiftRemaining = freeGiftMin.value - cartTotal.value;
    const inputString = /\[\{\{\{ remaining \}\}\}\]/g;

    return cartData.value.to_unlock_gift_html.replace(inputString, formatPrice(freeGiftRemaining));
  })

  const freeShippingPercentComplete = computed(() => {
    if (!cartData.value.enableGiftWithPurchase) {
      return Math.min(100, Math.max(0, (cartTotal.value / freeShippingMin.value) * 100));
    }

    const shippingPercentage = Math.min(50, (cartTotal.value / freeShippingMin.value) * 50);
    const freeGiftPercentage = (shippingPercentage === 50) ? Math.min(50, (cartTotal.value / freeGiftMin.value) * 100 - 50) : 0;
    
    return Math.min(100, Math.max(0, shippingPercentage + freeGiftPercentage));
  });

  const formatPrice = (price) => {
    return window.formattedPrice(price/100)
  }
</script>